export default __webpack_public_path__ + "static/media/graph.83b26b91.png";